import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Optional,
  Self
} from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[numberInput]'
})
export class NumberInputDirective {
  @Input() min      : number;
  @Input() max      : number;
  @Input() allowNull: boolean;

  constructor (
    private el: ElementRef<HTMLInputElement>,
    @Optional() @Self()
    private ngModel: NgModel
  ) {}

  @HostListener('input', [ '$event.target.value' ])
  onInput ( viewValue : string ) : void {
    if ( !this.ngModel ) return;

    const value = viewValue;

    if ( isNaN(parseFloat(value)) && value !== '-' ) {
      this.ngModel.control.setErrors({ valid: false });

      this.el.nativeElement.value = '';
      this.ngModel.viewToModelUpdate(this.allowNull ? '' : 0);

      return;
    }

    if ( this.isEmpty(value) ) {
      this.ngModel.control.setErrors(null);

      this.el.nativeElement.value = '';
      this.ngModel.viewToModelUpdate(this.allowNull ? '' : 0);

      return;
    }

    const hasMin = this.min !== undefined && this.min !== null;
    const hasMax = this.max !== undefined && this.max !== null;

    if ( hasMin && hasMax ) {
      const numericValue = parseFloat(value);

      if ( numericValue >= parseFloat(String(this.min)) && numericValue <= parseFloat(String(this.max)) ) {
        this.ngModel.control.setErrors(null);
      }
      else {
        this.ngModel.control.setErrors({ valid: false, range: false });
      }
    }
    else {
      this.ngModel.control.setErrors(null);
    }
  }

  private isEmpty ( value : any ) : boolean {
    return value == null || value === '' || (typeof value === 'number' && isNaN(value));
  }
}
